// Modules
import { Fragment, ReactElement, useState } from "react";

// Web Components
// import { BiuDropdown } from "../../biu-web-components/src/components";

// Styled Components
import * as EVENT from "./event.styles";
import * as TYPO from "../../styles/common/typo.styles";
import { MarginBottom, MarginTop } from "../../styles/common/space.styles";

// Constants
import { constant } from "../../constants/contant";

// Types
import { EventProps, Event } from "../../types/events";
import { useSelector } from "react-redux";
import { capitalizedLang } from "../../selectors/common.selector";

// Assets
import LeftArrow from "../../assets/left-arrow.svg";
import { useHistory, useParams } from "react-router-dom";
import AddToCalendar from "../add-to-calendar/add-to-calendar.component";
import DateMonth from "./event.dateMonth.component";
import { engWeekDaysParser } from "../../utils/common.utils";

const EventView = (props: EventProps): ReactElement => {
  const lang = useSelector((state: any) => capitalizedLang()(state));
  const included = useSelector((state: any) => state.event.included);
  const domainUnit = useSelector((state: any) => state.event.eventDomainField);
  const facets = useSelector((state: any) => state.facet);
  const dir = useSelector((state: any) => state.common.dir);

  const history = useHistory();
  const params: any = useParams();
  const [hover, setHover] = useState(false);

  if (props) {
    // Instance Of Event
    const event: Event = new Event({ ...props, lang, included, facets });
    const openUrl = (id: any) => {
      let currUrl = params.lang ? `/${params.lang}/event/${id}` : `/event/${id}`;
      if(domainUnit) {
        currUrl = params.lang ? `/${params.lang}/${params.domainUnit}/our-event/${id}` : `/${params.domainUnit}/our-event/${id}`;
      }
      history.push(currUrl);
    };
    // Render
    return (
      <EVENT.Card
        tabIndex={1}
        onMouseLeave={() => setHover(false)}
        onMouseOver={() => setHover(true)}
        onKeyPress={(keyEvent: any) => {
          if (keyEvent.key === "Enter") {
            openUrl(event.drupalInternalId);
          }
        }}
      >
        <DateMonth event={event}/>

        <EVENT.Highlighter>
          {event.isOnlineEvent && (
            <TYPO.BodyBoldSm>
              {constant[lang].VARIABLES.ONLINE_EVENT}
            </TYPO.BodyBoldSm>
          )}
          {event.isPhysicalEvent && (
            <TYPO.BodyBoldSm>
              {constant[lang].VARIABLES.PHYSICAL_EVENT}
            </TYPO.BodyBoldSm>
          )}
          {event.isCombinedEvent && (
            <TYPO.BodyBoldSm>
              {constant[lang].VARIABLES.COMBINED_EVENT}
            </TYPO.BodyBoldSm>
          )}
        </EVENT.Highlighter>
        <EVENT.Banner
            src={event.bannerUrl}
            onClick={() => openUrl(event.drupalInternalId)}
            alt="Banner"
        />

        <EVENT.Details>
          <EVENT.Content
            onClick={() => openUrl(event.drupalInternalId)}
          >
            <TYPO.BodyBoldXs margin={"none"}>{event.type}</TYPO.BodyBoldXs>
            <MarginTop size={8} />
            <TYPO.HeadingTwo>{event.title}</TYPO.HeadingTwo>
            <MarginTop size={14} />
            <TYPO.Body>{event.subTitleTrimmed}</TYPO.Body>
            <MarginTop size={32} auto />
            <EVENT.TypeView>
              <TYPO.BodyBoldXs margin={"none"}> {event.cost}</TYPO.BodyBoldXs>
              {event.inviteType && (
                <>
                  <EVENT.TextDivider margin={"none"}>|</EVENT.TextDivider>
                  <TYPO.BodyBoldXs margin={"none"}>
                    {event.inviteType}
                  </TYPO.BodyBoldXs>
                </>
              )}
            </EVENT.TypeView>
          </EVENT.Content>
          <EVENT.Separator />
        </EVENT.Details>
        <EVENT.ActionView>
          <MarginTop auto />

          {event.fullDate && (
            <>
              <TYPO.Body>{event.fullDate}</TYPO.Body>
              <MarginTop size={8} />
            </>
          )}
          {event.hebrewDate && (
            <>
              <TYPO.Body>{params.lang === 'en' ? engWeekDaysParser(event.hebrewDate) : event.hebrewDate}</TYPO.Body>
              <MarginTop size={8} />
            </>
          )}
          {event.time && (
            <>
              <TYPO.Body>{event.time}</TYPO.Body>
              <MarginTop size={16} />
            </>
          )}

          <AddToCalendar lang={lang} event={event} />

          <MarginBottom size={32} />
          <EVENT.LeftArrow direction={dir} hover={hover} src={LeftArrow} alt="Left Arrow"/>
        </EVENT.ActionView>
      </EVENT.Card>
    );
  }

  //  Return Empty JSX Element
  return <Fragment />;
};

export default EventView;
